export default "__VITE_ASSET__63780cac__"